import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { FaSlidersH } from 'react-icons/fa'
import { Tooltip } from 'primereact/tooltip'
import { Dock } from 'primereact/dock'

import useResize from '../../../_core/hooks/useResize'
import BreakpointRender from '../../../_core/components/breakpoint-render'
import { dislikeUser, likeUser } from '../../../../../common/_services/likes.service'
import { getRandomUserId } from '../../../../../common/_services/users.service'

import ProfileBox from '../_components/profile/profileBox'
import HotListMessages from '../_components/hotlistMessages'
import MessagesBox from '../_components/messagesBox'
import SidebarWrapper from '../_components/profile/components/SidebarWrapper'
import UserPreferences from '../_components/profile/components/UserPreferences'
import Loader from '../../../components/loader'
import NoData from '../../../components/noData'
import LikesMe from '../screens/web-mobile/likes-me'
import Chat from '../screens/web-mobile/chat'

const undefinedToNull = <a,>(x:a | undefined) : a | null => x === undefined ? null : x

const DiscoverLayout = () => {
  const params = useParams()
  const breakpoint = useResize()
  const [showPref, setShowPref] = useState<boolean>(false)
  const [preferencesChanged, setPreferencesChanged] = useState<boolean>(false)
  const [userId, setUserId] = useState<string | null | undefined>()
  //const [stateVideoWatched, setVideoWatched] = useState(!!localStorage.getItem('video-watched'))

  const openPreferences = () => {
    setPreferencesChanged(false)
    setShowPref(true)
  }
  const closePreferences = () => {
    if(preferencesChanged && !params.userId)
    {
      setUserId(undefined)
      getRandomUserId().then(setUserId)
    }
    setShowPref(false)
  }
  useEffect(() => {
    if(!!params.userId)
    {
      setUserId(params.userId)
    }
    else if(!params.kind)
    {
      getRandomUserId().then(setUserId)
    }
  },[params])


  // const watchedVideo = () => {
  //   localStorage.setItem('video-watched', 'yes')
  //   setVideoWatched(true)
  // }

  const onLikePressed = async (userId: string) => {
    await likeUser(userId)
    setUserId(undefined)
    setUserId(await getRandomUserId())
  }

  const onDislikePressed = async (userId: string) => {
    await dislikeUser(userId)
    setUserId(undefined)
    setUserId(await getRandomUserId())
  }

  const likeDislike = [onLikePressed,onDislikePressed] as [(_:string) => Promise<void>,(_:string) => Promise<void>]

  const items = [
    {
      label: 'Preferences',
      icon: () => <FaSlidersH className="mx-2" size={30} color="gray" onClick={openPreferences} />,
    },
  ]

  return (
    <div className="d-flex gap-2 h-100 w-100">
      {/* <VideoModal
        id='VideoModal'
        className='half-width-media'
        header={`Welcome ${user?.firstName + ' ' + user?.lastName} to DAtP`}
        subTitle='In an ambitious move, DateBritishGuys.com is expanding its horizons. Now rebranded as
        DatingAcrossthePond.com, the platform will cater to a global audience. This means you’re no longer
        limited to the charming blokes of Britain. Instead, you can broaden your romantic endeavors to
        include anyone with an accent, from anywhere in the world. Because if there’s one thing better
        than a British accent, it’s an array of accents from around the globe, each bringing its own
        delightful miscommunications and cultural quirks.'
        src='https://www.youtube.com/embed/HmQzh9GLMHQ?autoplay=1&control=1'
        visible={!stateVideoWatched}
        onHide={() => watchedVideo()}
        onClose={() => watchedVideo()}
        buttonLabel='Continue'
        buttonIcon='pi pi-star'
        iconPos='right'
        style={{ width:'100%',maxWidth:'850px',maxHeight:'100%' }}
      /> */}
      <BreakpointRender gte={!!params.userId ? 'xl' : 'lg'}>
        <HotListMessages
          tab={params.kind === 'messages' || params.kind === 'likes' ? params.kind : 'matches'}
          userId={undefinedToNull(userId)}
        />
      </BreakpointRender>
      <Loader loading={!params.kind && userId === undefined}>
        <SidebarWrapper onHide={closePreferences} visible={showPref} position="right" title="Preferences">
          <UserPreferences onChange={() => setPreferencesChanged(true)} />
        </SidebarWrapper>
        {
          params.kind === 'likes' && params.userId === undefined
          ? <LikesMe></LikesMe>
          : params.kind === 'messages' && params.userId === undefined
          ? <Chat></Chat>
          : userId === null
          ?
            <NoData>
              <div className="flex text-center">
                <br/>
                <br/>
                <br/>
                <h3>
                  Looking for more sparks?
                </h3>
                <button type="button" className="btn btn-primary" onClick={() => setShowPref(true)}>Expand Preferences</button>
              </div>
            </NoData>
          : params.kind === 'likes' || params.kind === undefined
          ?
          <>
            <Tooltip target=".preference-tooltip" />
            <BreakpointRender eq="desktop">
              <Dock
                model={items}
                data-pr-tooltip="Preferences"
                position="right"
                className="d-block preference-tooltip"
                data-pr-at="left-100 bottom"
                data-pr-my="left center-89"
                data-pr-showdelay={272}
              ></Dock>
            </BreakpointRender>
            <BreakpointRender eq="mobile">
              <Dock
                model={items}
                position="right"
                className="d-block position-fixed"
                style={{ 'marginTop':'-30px' }}
                data-pr-at="left-100 bottom"
                data-pr-my="left center-100"
                data-pr-showdelay={272}
              ></Dock>
            </BreakpointRender>
            {userId &&
            <ProfileBox
              userId={userId}
              showBlockReport
              showLikeDislike={likeDislike}
            />
            }
          </>
          : params.kind === 'profile' && breakpoint.isMobile
          ?
            userId &&
            <ProfileBox
              userId={userId}
              showBlockReport
            />
          :
            <Loader loading={!userId}>
              <MessagesBox userId={userId!}/>
              <BreakpointRender gte="md">
                <ProfileBox
                  userId={userId!}
                  showBlockReport
                />
              </BreakpointRender>
            </Loader>
        }
      </Loader>
    </div>
  )
}

export default React.memo(DiscoverLayout)
